import React, { useMemo, memo, forwardRef } from 'react';
import classnames from 'classnames';
import styles from './button.module.scss';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: JSX.Element | string,
  isLoading?: boolean,
  buttonStyles?: string,
  animationStyles?: string,
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  children,
  className,
  isLoading,
  disabled,
  style,
  buttonStyles,
  animationStyles,
  ...rest
}, ref) => {
  const buttonStyle = useMemo(() => ({ ...style }), [style]);

  return (
    <button
      ref={ref}
      type='button'
      style={buttonStyle}
      className={classnames('defaultButton', buttonStyles)}
      disabled={isLoading || disabled}
      {...rest}
    >
      <div className={animationStyles} />
      <div className={className}>
        {children}
      </div>
    </button>
  )
})

Button.displayName = 'Button';

Button.defaultProps = {
  isLoading: false,
};

export default memo(Button);